package co.maytes.standupbot.dashboard.features.analytics

import co.maytes.standupbot.shared.csv.AnalyticsCsv
import co.maytes.standupbot.shared.dto.analytics.CostsDto
import co.maytes.standupbot.shared.dto.analytics.ParticipationDto
import co.maytes.standupbot.shared.dto.analytics.VelocityDto
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLAnchorElement
import org.w3c.dom.url.URL

object AnalyticsCsvExport {
    fun export(
        costs: CostsDto?,
        velocity: VelocityDto?,
        participation: ParticipationDto?,
        rangeLabel: String,
    ) {
        val suffix = rangeLabel.lowercase().replace(Regex("[^a-z0-9]+"), "-").trim('-')
        costs?.let { triggerDownload("costs-$suffix.csv", AnalyticsCsv.costs(it)) }
        velocity?.let { triggerDownload("weekly-activity-$suffix.csv", AnalyticsCsv.velocity(it)) }
        participation?.let { triggerDownload("participation-$suffix.csv", AnalyticsCsv.participation(it)) }
    }

    private fun triggerDownload(filename: String, contents: String) {
        val blob = org.w3c.files.Blob(
            arrayOf(contents),
            org.w3c.files.BlobPropertyBag(type = "text/csv;charset=utf-8"),
        )
        val url = URL.createObjectURL(blob)
        val a = document.createElement("a") as HTMLAnchorElement
        a.href = url
        a.setAttribute("download", filename)
        a.style.display = "none"
        document.body?.appendChild(a)
        a.click()
        document.body?.removeChild(a)
        window.setTimeout({ URL.revokeObjectURL(url); null }, 2000)
    }
}
